module.exports = __webpack_public_path__ + "static/sentinel-logo-1525f9dc71f5cf63ece1e9926902c36e.png";